import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "text-center",
  style: {
    "margin-top": "30px"
  }
};
var _hoisted_2 = /*#__PURE__*/_createTextVNode("下载证书");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_image = _resolveComponent("a-image");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.show.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.show.visible = $event;
    }),
    width: 700,
    title: null,
    header: null,
    footer: null,
    "mask-closable": false,
    class: "userCertificateDialogClass"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_image, {
        src: _ctx.imageUrl,
        width: "100%"
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_a_button, {
        type: "primary",
        shape: "round",
        size: "large",
        class: "btn-download",
        onClick: _ctx.onDownloadClick
      }, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    _: 1
  }, 8, ["visible"]);
}